import axios from "axios";
import { BASE_URL_ADMIN } from "../../Config/BaseUrl";
import { appToken} from "../../utils/storageHelper";

// Create Axios instance
const api = axios.create({
  baseURL: BASE_URL_ADMIN,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor: attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = appToken(); //fetch token from storage helper
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 0) {
      console.warn("Unauthorized! Redirecting to login.");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
